(function ($) {
    $(function () {
        $('#vat_invoice').on('change', function () {
            $('.js-vat-blocks').addClass('d-none');
            $('.js-no-vat-blocks').removeClass('d-none');
            $('#tax_number_val').attr('required', false);
            $('#company').attr('required', false);
            $('#billing_name').attr('required', true);
            $('#tax_number_val').val('');
            $('#company').val('');
            var infoText = $('#tax_number_val').parent().find('.form-group__info').data('optional');
            if (document.getElementById('vat_invoice').checked) {
                $('.js-vat-blocks').removeClass('d-none');
                $('.js-no-vat-blocks').addClass('d-none');
                infoText = $('#tax_number_val').parent().find('.form-group__info').data('required');
                $('#tax_number_val').attr('required', true);
                $('#company').attr('required', true);
                $('#billing_name').attr('required', false);
                $('#tax_number_val').val($('#tax_number_val').data('value'));
                $('#company').val($('#company').data('value'));
            }
            $('#tax_number_val').parent().find('.form-group__info').html(infoText);
            $('#company').parent().find('.form-group__info').html(infoText);
        });
        $('#registration').on('change', function () {
            $('#passwd_block').addClass('d-none');
            $('#password').attr('required', false);
            $('#password_confirmation').attr('required', false);
            if (document.getElementById('registration').checked) {
                $('#passwd_block').removeClass('d-none');
                $('#password').attr('required', true);
                $('#password_confirmation').attr('required', true);
            }
        });
        $('.js-copy-billing').on('click', function () {
            $('.js-copy-data').each(function () {
                $(this).val($($(this).data('copy-from')).val());
                if ($(this).data('submit') == true) {
                    $(this).parents('.row').children('.col-md-6').children('.cta').children('.js-send-element').trigger('click');
                }
            });
        });
        $('#different_shipping').on('change', function () {
            $('.js-copy-data').each(function () {
                $(this).val($($(this).data('copy-from')).val());
            });
            if (document.getElementById('different_shipping').checked) {
                $('.js-shipping-block').removeClass('d-none');
                $('.js-required-if-shipping').each(function () {
                    $(this).prop('required', true);
                });
            } else {
                $('.js-shipping-block').addClass('d-none');
                $('.js-required-if-shipping').each(function () {
                    $(this).prop('required', false);
                });
            }
        });

        $('.shipping-select-box .select-box__item').click(function () {
            var isRequired = false;
            var shipping_type = false;
            var infoText = $('#tax_number_val').parent().find('.form-group__info').data('optional');
            $('.shipping-select-box').find('input').prop('checked', false).removeAttr('checked');
            $(this).find('input').prop('checked', true).attr('checked', true);
            if ($('input:radio[name=shipping_method]:checked', this).data('shipping_method') === "courier") {
                isRequired = true;
                infoText = $('#tax_number_val').parent().find('.form-group__info').data('required');
                shipping_type = 'hu';
            }

            if ($('input:radio[name=shipping_method]:checked', this).data('shipping_method') === "courier_eu") {
                isRequired = true;
                infoText = $('#tax_number_val').parent().find('.form-group__info').data('required');
                shipping_type = 'eu';
            }
            $('.js-required-if-shipping').each(function () {
                $(this).attr('required', isRequired);
                $(this).parent().find('.form-group__info').html(infoText);
            });
            
            $('.js-courier-price').addClass('d-none');
            $('.js-courier-eu-price').addClass('d-none');
            $('.js-shipping-block').addClass('d-none');
            
            if (isRequired === true) {
                if(shipping_type == 'hu') $('.js-courier-price').removeClass('d-none');
                else $('.js-courier-eu-price').removeClass('d-none');
                $('.js-shipping-block').removeClass('d-none');
            }
            updateFullPrice();
        });

        $('.js-checkout-btn').click(function () {
            const isAnyChecked = $('.select-box__item input')
                .map(function (_, input) { return input.checked; })
                .get()
                .some(Boolean);
            if (!isAnyChecked) {
                $('.select-box__item').addClass('has-error');
                $('.select-box__error').show();
            }
        });

        $('#checkout-form').on('submit', function (e) {
            $('.js-checkout-btn').prop('disabled', true).addClass('is-loading');
            $('.js-checkout-btn').find('.btn-text').addClass('d-none');
            $('.js-checkout-btn').find('.btn-spinner').removeClass('d-none');
        });

        // If only one option is available select that immediately
        if ($('.shipping-select-box .select-box__item').length === 1) {
            $('.shipping-select-box .select-box__item').click();
        }

    });
})(jQuery);
